const makeClickable = (el, i) => {
  if (el.dataset?.location) {
    el.addEventListener("click", (event) => {
      if (el.dataset?.openInNewTab === "true") {
        window.open(el.dataset.location, "_blank", "noopener,noreferrer");
      } else {
        window.location.href = el.dataset.location;
      }
    });
  }
};

export default makeClickable;

export const initMakeClickable = () => {
  document
    .querySelectorAll(".js-make-clickable-element")
    .forEach(makeClickable);
};
